import { Box, Stack, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useReportStore } from "../../../data/ReportStore";
import { Team } from "../../../models/Team";
import {
  useLeagueEnvironment,
  useLeagueLogo,
  useLeaguePaths,
} from "../../../data/LeagueEnvironmentProvider";
import Grid2 from "@mui/material/Unstable_Grid2";
import { blue } from "@mui/material/colors";

export default function TeamTileList() {
  const environment = useLeagueEnvironment();
  const getTeamLogoUrl = useLeagueLogo();
  const { getReportsTeamPath } = useLeaguePaths();
  const teams = useReportStore(
    (store) => store.teamsByEnvironment[environment] ?? []
  );

  if (!teams || teams.length === 0) {
    return null;
  }

  // Sort teams alphabetically by abbreviation
  const sortedTeams = [...teams].sort((a: Team, b: Team) =>
    a.abbrev.localeCompare(b.abbrev)
  );

  return (
    <Grid2 className="TeamTileList" container>
      {sortedTeams.map(({ abbrev, nbaId, city, name }: Team) => {
        const linkUrl = getReportsTeamPath(abbrev);
        return (
          <Grid2 key={abbrev} xs={6} sm={4} md={3} lg={2} sx={{ py: 0.5 }}>
            <Box sx={{ width: "fit-content" }}>
              <Link
                to={linkUrl}
                component={RouterLink}
                underline="none"
                sx={{
                  "&:hover": {
                    ".MuiTypography-root": {
                      color: blue[800],
                      textDecoration: "underline",
                    },
                    img: {
                      filter: `drop-shadow(2px 1px 0px ${blue[800]})`,
                    },
                  },
                }}
              >
                <Stack direction="row" gap={1}>
                  <Box
                    component="img"
                    className="team-tile-list--logo"
                    src={getTeamLogoUrl(nbaId)}
                    alt={`${city} ${name} logo`}
                    sx={{
                      width: 50,
                      height: 50,
                      filter: "drop-shadow(2px 1px 0px rgba(0, 0, 0, 0.5))",
                    }}
                  />
                  <Stack
                    sx={{
                      height: "100%",
                      justifyContent: "center",
                      ".MuiTypography-root": {
                        lineHeight: 1.3,
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        color: "black",
                      },
                    }}
                  >
                    <Typography>
                      {city}
                      <br />
                      <Typography
                        variant="inherit"
                        component="span"
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {name}
                      </Typography>
                    </Typography>
                  </Stack>
                </Stack>
              </Link>
            </Box>
          </Grid2>
        );
      })}
    </Grid2>
  );
}
